import api from "@/api/api.js";

/**
 * Documentos legales (tarjeta #4): aviso de privacidad, contrato y protocolo.
 * El backend sirve los PDF y guarda cada aceptación con el hash de lo que se
 * aceptó; aquí solo se piden y se abren.
 */

export const LEGAL = {
  privacy: "aviso_privacidad",
  contract: "contrato_servicios",
  protocol: "protocolo_incidentes",
};

/** El aviso y el protocolo son públicos: se pueden enlazar sin sesión. */
export const publicLegalUrl = (document) =>
  `${import.meta.env.VITE_API_URL}/api/legal/documents/${document}`;

/**
 * Abre un PDF que pide sesión (el contrato lleva los datos de quien lo va a
 * aceptar) en una pestaña nueva. La pestaña se abre antes de pedirlo: si se
 * abre después de esperar la respuesta, el navegador la bloquea.
 */
const openPdf = async (path) => {
  const tab = window.open("", "_blank");
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  if (tab) {
    tab.location.href = url;
  } else {
    window.location.href = url;
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};

export const openLegalDocument = (document) =>
  document === LEGAL.contract
    ? openPdf(`/legal/documents/${document}`)
    : window.open(publicLegalUrl(document), "_blank", "noopener");

export const openAcceptedPdf = (id) => openPdf(`/legal/acceptances/${id}/pdf`);

export const fetchLegalStatus = () =>
  api.get("/legal/status").then(({ data }) => data);

export const acceptLegal = (documents) =>
  api.post("/legal/acceptances", { documents }).then(({ data }) => data);

export const fetchLegalHistory = () =>
  api.get("/legal/acceptances").then(({ data }) => data);

/** Para el contador: qué le falta aceptar al dueño de la empresa. */
export const fetchCompanyLegal = (companyId) =>
  api.get(`/legal/companies/${companyId}`).then(({ data }) => data);
